/* Main-menu theme registry — built-in default + workshop packs from the player-side
   mod store (components/cef/packs.js). Active pick lives in the pack store. */

import { listInstalled, activePack, setActivePack, installPack } from "@/components/cef/packs";

export const BUILTIN_THEMES = [
  {
    id: "default", name: "New Citizen Blue", byline: "The stock look", official: true,
    accent: "#2E6BFF", tint: "", stripes: [], bootTitle: "", tagline: "Default cinematic blue",
    font: "default", glow: 0.7, buttons: "sharp",
  },
];

function packToTheme(mod) {
  const t = mod?.pack?.theme;
  if (!t?.accent) return null;
  return {
    id: `pack:${mod.id}`, name: mod.title, byline: `by ${mod.author_name}`, official: !!mod.official,
    accent: t.accent, tint: t.tint || "", stripes: t.stripes || [],
    bootTitle: t.boot_title || "", tagline: t.tagline || "",
    font: t.font || "default", glow: t.glow ?? 0.7, buttons: t.buttons || "sharp",
  };
}

export function allThemes() {
  const packs = listInstalled("menu_theme").map(packToTheme).filter(Boolean);
  return [...BUILTIN_THEMES, ...packs];
}

export function activeTheme() {
  const mod = activePack("menu_theme");
  const t = mod && packToTheme(mod);
  return t || BUILTIN_THEMES[0];
}

export function setActiveTheme(id) {
  setActivePack("menu_theme", id.startsWith("pack:") ? id.slice(5) : id);
}

// compat for WorkshopPage
export function installedPacks() {
  return listInstalled("menu_theme");
}

export function installThemePack(mod) {
  installPack(mod);
}
